import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { FilterByOptionForOptionPmsPresenter } from "./presenter";
import * as Repository from "../../_repository";

type ChildrenProps = {
	filteredOptionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
};

type Props = {
	hotelID: string;
	// 検索日
	searchDate: string;
	children: ({ filteredOptionPmsActiveListQueryData }: ChildrenProps) => JSX.Element;
};

export const FilterByOptionForOptionPmsContainer = ({
	hotelID,
	// 検索日
	searchDate,
	//
	children,
}: Props) => {
	/**
	 * オプションカラーリストの取得
	 */
	const { optionPmsOptionListQueryData } = Repository.Query.UseCase.useOptionPmsOptionListQuery({ hotelID });
	/**
	 * PMS リストの取得
	 */
	const { optionPmsActiveListQueryData } = Repository.Query.UseCase.useOptionPmsActiveListQuery({
		hotelID,
		date: searchDate,
	});

	if (!optionPmsOptionListQueryData || !optionPmsActiveListQueryData) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<FilterByOptionForOptionPmsPresenter
			optionPmsOptionListQueryData={optionPmsOptionListQueryData}
			optionPmsActiveListQueryData={optionPmsActiveListQueryData}
			children={children}
		/>
	);
};
